import PropTypes from 'prop-types';
import {
    DATA_TABLE_COLUMN_TYPE_NUMBER,
    DATA_TABLE_COLUMN_TYPE_STRING,
    DATA_TABLE_COLUMN_TYPE_DATE,
    DATA_TABLE_COLUMN_TYPE_SELECT,
    DATA_TABLE_COLUMN_TYPE_HIDDEN,
    DATA_TABLE_COLUMN_TYPE_STATUS,
    DATA_TABLE_COLUMN_TYPE_AUTHOR,
    DATA_TABLE_COLUMN_TYPE_LINK,
    DATA_TABLE_COLUMN_TYPE_PROCESS_STATUS,
    DATA_TABLE_COLUMN_TYPE_ACTIONS,
    DATA_TABLE_COLUMN_TYPE_ICON_STATUS,
    DATA_TABLE_FILTER_TYPE_STRING,
    DATA_TABLE_FILTER_TYPE_COMPLEX_STRING,
    DATA_TABLE_FILTER_TYPE_DATE,
    DATA_TABLE_FILTER_TYPE_SELECT,
    DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_SINGLE,
    DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_MULTI,
    DATA_TABLE_COLUMN_TYPE_FORMATTED_MESSAGE
} from 'Constants';

export const SelectType = PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

export const ColumnType = PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string,
    type: PropTypes.oneOf([
        DATA_TABLE_COLUMN_TYPE_NUMBER,
        DATA_TABLE_COLUMN_TYPE_STRING,
        DATA_TABLE_COLUMN_TYPE_DATE,
        DATA_TABLE_COLUMN_TYPE_SELECT,
        DATA_TABLE_COLUMN_TYPE_HIDDEN,
        DATA_TABLE_COLUMN_TYPE_STATUS,
        DATA_TABLE_COLUMN_TYPE_AUTHOR,
        DATA_TABLE_COLUMN_TYPE_LINK,
        DATA_TABLE_COLUMN_TYPE_PROCESS_STATUS,
        DATA_TABLE_COLUMN_TYPE_ACTIONS,
        DATA_TABLE_COLUMN_TYPE_ICON_STATUS,
        DATA_TABLE_COLUMN_TYPE_FORMATTED_MESSAGE
    ]),
    filterType: PropTypes.oneOf([
        DATA_TABLE_FILTER_TYPE_STRING,
        DATA_TABLE_FILTER_TYPE_COMPLEX_STRING,
        DATA_TABLE_FILTER_TYPE_DATE,
        DATA_TABLE_FILTER_TYPE_SELECT,
        DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_SINGLE,
        DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_MULTI
    ]),
    filterPlaceholder: PropTypes.string,
    filterLibraryParams: PropTypes.object,
    optionsIsLoading: PropTypes.bool,
    options: PropTypes.arrayOf(SelectType),
    loadOptions: PropTypes.func,
    sortable: PropTypes.bool,
    sortableKey: PropTypes.string,
    filterable: PropTypes.bool,
});

export const ItemType = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

export const QueryFilterType = PropTypes.shape({
    where: PropTypes.object,
    include: PropTypes.array,
    page: PropTypes.number,
    order: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    group: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
});

export const MetadataType = PropTypes.shape({
    lastPage: PropTypes.number,
    page: PropTypes.number,
    perPage: PropTypes.number,
    total: PropTypes.number,
});



// WEBPACK FOOTER //
// ./src/types/dataTable.js